import { useEffect, useState } from "react";

const BookmarksSection=()=>{
    const [quranBookmarks,setQuranBookmarks]=useState(null);
    const [kidsQuranBookmarks,setKidsQuranBookmarks]=useState(null);
    const [recitationBookmarks,setRecitationBookmarks]=useState(null);

    const initBookmarks=()=>{
        const bookmarksArr=JSON.parse(localStorage.getItem('translationBookmarks'));
        const recentInsights=JSON.parse(localStorage.getItem('recentInsights'));
        if (bookmarksArr) {
            const quranItems = bookmarksArr.filter(item => item.type === 'regular');
            const kidsItems = bookmarksArr.filter(item => item.type !== 'regular');
            
            setQuranBookmarks(quranItems);
            setKidsQuranBookmarks(kidsItems);
        }

        if(recentInsights)
        {
            const bookmarkedItem = recentInsights.find(item => item.pageType === "recite-surah-bookmark");
            setRecitationBookmarks(bookmarkedItem);
        }
    }

    const removeBookmark = (surahID, ayahID, bookmarkType) => {
        // Retrieve bookmarks from localStorage
        const bookmarksArr = JSON.parse(localStorage.getItem('translationBookmarks')) || [];
        // Filter out the item matching the parameters
        const updatedBookmarks = bookmarksArr.filter(
            bookmark => !(bookmark.surahNumber === surahID && bookmark.ayahNumber === ayahID && bookmark.type === bookmarkType)
        );
        // Update the localStorage with the filtered bookmarks array
        localStorage.setItem('translationBookmarks', JSON.stringify(updatedBookmarks));
        // Check if createBookmarkIcon is a function and call it
        if (typeof createBookmarkIcon === 'function'&&!location.pathname.includes('kids-quran')) {
            createBookmarkIcon();
        }

        initBookmarks();
    };

    useEffect(()=>{
        initBookmarks();
    },[]);

    return(
        <>
            {
                quranBookmarks&&quranBookmarks.length>0?
                    <>
                        <p className="pb-3 border-b border-deep-blue mb-2 text-white">Al-Qur'an Translation</p>
                        {
                            quranBookmarks.map((bookmark, bookmarkIndex)=>{
                                const bookmarkName="Surah "+bookmark.surahNumber+" : Ayah "+bookmark.ayahNumber;
                                const bookmarkLink="/quran/read-surah/"+bookmark.surahNumber+"?qRef="+bookmark.ayahNumber;

                                return(
                                    <div key={bookmarkIndex} className="flex justify-between">
                                        <a href={bookmarkLink}>
                                            <div className="flex items-center p-2 text-gray-900 transition duration-75 rounded-lg text-white cursor-pointer">
                                                <img src="/images/quran-bookmark.svg" width="17" height="17" alt="Bookmark icon" className=""/>
                                                <span className="ml-3">{bookmarkName}</span>
                                            </div>
                                        </a>
                                        <button className="cursor-pointer rounded-full bg-white bg-opacity-10 h-8 w-8" onClick={()=>{
                                            removeBookmark(bookmark.surahNumber,bookmark.ayahNumber,bookmark.type);
                                        }} title="Remove bookmark">
                                            <img src="/images/close.svg" width="14" height="15" alt="Bookmark Close" className="mx-auto"/>
                                        </button>
                                    </div>
                                )
                            })
                        }
                    </>
                :
                    null
            }

            {
                kidsQuranBookmarks&&kidsQuranBookmarks.length>0?
                    <>
                        <p className="pb-3 border-b border-deep-blue mb-2 text-white">Al-Qur'an Kids</p>
                        {
                            kidsQuranBookmarks.map((bookmark, bookmarkIndex)=>{
                                const bookmarkName="Surah "+bookmark.surahNumber+" : Ayah "+bookmark.ayahNumber;
                                const bookmarkLink="/kids-quran/read-surah/"+bookmark.surahNumber+"?qRef="+bookmark.ayahNumber;

                                return(
                                    <div key={bookmarkIndex} className="flex justify-between">
                                        <a href={bookmarkLink}>
                                            <div className="flex items-center p-2 text-gray-900 transition duration-75 rounded-lg text-white cursor-pointer">
                                                <img src="/images/kids-quran-bookmark.svg" width="17" height="17" alt="Bookmark icon" className=""/>
                                                <span className="ml-3">{bookmarkName}</span>
                                            </div>
                                        </a>
                                        <button className="cursor-pointer rounded-full bg-white bg-opacity-10 h-8 w-8" onClick={()=>{
                                            removeBookmark(bookmark.surahNumber,bookmark.ayahNumber,bookmark.type);
                                        }} title="Remove bookmark">
                                            <img src="/images/close.svg" width="14" height="15" alt="Bookmark Close" className="mx-auto"/>
                                        </button>
                                    </div>
                                )
                            })
                        }
                    </>
                :
                    null
            }

            {
                recitationBookmarks?
                    <>
                        <p className="pb-3 border-b border-deep-blue mb-2 text-white mt-5">Al-Qur'an recitation</p>
                        <div className="flex justify-between mb-2">
                            <a href={`/quran/recite-surah/${parseInt(recitationBookmarks.surahNumber, 10)}?qRef=${recitationBookmarks.scrollPos}`} className="grow">
                                <div className="flex items-center p-2 transition duration-75 rounded-lg text-white cursor-pointer">
                                    <img src="/images/quran-bookmark.svg" width="17" height="17" alt="Bookmark icon" className=""/>
                                    <span className="ml-3">{`Surah ${parseInt(recitationBookmarks.surahNumber, 10)} : Ayah ${recitationBookmarks.scrollPos}`}</span>
                                </div>
                            </a>
                        </div>
                    </>
                :
                    null
            }

            {
                ((quranBookmarks === null || (Array.isArray(quranBookmarks) && quranBookmarks.length === 0)) &&
                (kidsQuranBookmarks === null || (Array.isArray(kidsQuranBookmarks) && kidsQuranBookmarks.length === 0)) &&
                !recitationBookmarks) ?
                    <p className="text-white">No bookmarks found</p>
                :
                    null
            }
        </>
    );
}

export default BookmarksSection;